<template>
    <div class="tw-tabpanel">
        <slot></slot>
    </div>
</template>

<script>
export default {
    // 需配合TabView组件，所以命名只能使用TabPanel
    name: 'TabPanel',
    props: {
        header: {
            type: String,
            default: "选项卡"
        },
        disabled: Boolean
    }
}
</script>
